<ion-card>
    <ion-card-content>
        <ion-fab vertical="center" horizontal="end" *ngIf="document.clockingState === 1">
            <ion-fab-button (click)="clockTick()" size="small" [color]="document.clockingState === 1 ? 'success' : 'danger'">
                <ion-icon [name]="document.clockingState === 1 ? 'add' : 'close'"></ion-icon>
            </ion-fab-button>
        </ion-fab>
        <ion-fab vertical="center" horizontal="end"  *ngIf="document.clockingState === 2">
            <ion-fab-button (click)="clockTick()" size="small" color="danger">
                <ion-icon name="close"></ion-icon>
            </ion-fab-button>
        </ion-fab>
        <ion-label *ngIf="document.clockingState === 1">Start Time</ion-label>
        <ion-label *ngIf="document.clockingState === 2">Stop Time</ion-label>
    </ion-card-content>
    <ion-card-content *ngIf="timeLogs.length">
        <ion-grid>
            <ion-row>
                <ion-col>
                    <b>Date</b>
                </ion-col>
                <ion-col class="ion-text-center">
                    <b>Time(Hours)</b>
                </ion-col>
            </ion-row>
            <ion-row *ngFor="let entry of timeLogs">
                <ion-col>
                    {{ entry.date | date: 'dd/MM/yyyy' }}
                </ion-col>
                <ion-col class="ion-text-center">
                    {{ round(entry.duration) }}
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Total Hours Logged</b>
                </ion-col>
                <ion-col class="ion-text-center">
                    <b>{{ round(totalHours) }}</b>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card-content>
</ion-card>
